import { SVGProps } from "react";

export const Calendar2Icon = ({
  size = 16,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg fill="none" viewBox="0 0 24 24" width={size} height={size} {...rest}>
      <path
        d="M5.5 1.5v4 M9.5 1.5v4 M13.5 1.5v4 M17.5 1.5v4 M22.5 3.5H0.5v20h22v-20Z M7.5 12.5v-4h12v12h-16v-8h4Z M7.5 12.5v8 M11.5 8.5v12 M15.5 8.5v12 M7.5 12.5h12 M3.5 16.5h16"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  return render();
};
